import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { withRouter, Link } from "react-router-dom";

import { Spin } from "antd";
import { Card, Row, Col } from "react-bootstrap";
import PsContext from "../../../context";
import { ServiceUrl } from "../../../utils/serviceUrl";
import ErrorPage404 from "../homePage/errorPage404";
import { APP_TYPE, DB_POSTFIX } from "../../../utils";

const WebPages = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [pageId, setPageId] = useState(null);

  useEffect(() => {
    //loadPage();
    if (pageId != props.match.params.pageId)
      setPageId(props.match.params.pageId);
    //$("html, body").animate({ scrollTop: 0 }, "slow");
  }, [props.match.params]);

  useEffect(() => {
    if (pageId) loadPage();
  }, [pageId]);

  const loadPage = () => {
    setLoader(true);
    let url = "";
    if (APP_TYPE == "SAAS") url = "&sadb=" + DB_POSTFIX;
    axios
      .get(
        ServiceUrl.ADMISSION.CUSTOM_PAGE +
          "?slug=" +
          props.match.params.pageId +
          url,
      )
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
        } else {
          setDataList([]);
        }
        setLoader(false);
      });
  };

  return (
    <>
      <div
        className="admission-breadcrumb-strip py-2 mb-3 d-none d-md-block"
        style={{ backgroundColor: "#f2f3f5ff !important" }}
      >
        <div className="container">
          <Row className="align-items-center">
            <Col md={12}>
              <ol className="breadcrumb mb-0 bg-transparent p-0 fs-13 fw-600">
                <li className="breadcrumb-item">
                  <Link to="/" className="text-secondary opacity-75">
                    <i className="fas fa-home me-1"></i> Home
                  </Link>
                </li>
                <li className="breadcrumb-item active text-dark">
                  {dataList && dataList.title}
                </li>
              </ol>
            </Col>
          </Row>
        </div>
      </div>
      <div className="container py-4 mb-5">
        <Spin spinning={loader}>
          <div style={{ minHeight: "250px" }}>
            {dataList && dataList.id && (
              <Card>
                <Card.Body>
                  <h3
                    className="title_with_halfLine my-3 "
                    style={{ textTransform: "capitalize" }}
                  >
                    {dataList.title}
                  </h3>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: dataList.content_html,
                    }}
                  />
                </Card.Body>
              </Card>
            )}
            {!loader && !dataList.id && <ErrorPage404 />}
          </div>
        </Spin>
      </div>
    </>
  );
};

export default withRouter(WebPages);
